/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ row: NonNullable<unknown> }} Knp_Terms_Csv_Row_Missing_TermInputs */



/**
* | output |
* | --- |
* | "Row {row}: Missing term" |
*
* @param {Knp_Terms_Csv_Row_Missing_TermInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_csv_row_missing_term = /** @type {((inputs: Knp_Terms_Csv_Row_Missing_TermInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Csv_Row_Missing_TermInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ligne ${i?.row} : terme manquant`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Zeile ${i?.row}: Fehlender Term`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Riga ${i?.row}: Termine mancante`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Строка ${i?.row}: Отсутствует термин`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Fila ${i?.row}: Término faltante`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`行 ${i?.row}：缺少项`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`行 ${i?.row}: 用語が見つかりません`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पंक्ति ${i?.row}: पद अनुपलब्ध है`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Linha ${i?.row}: Termo ausente`)
	return /** @type {LocalizedString} */ (`Row ${i?.row}: Missing term`)
});